export enum KycStatus {
    INCOMPLETE = 'INCOMPLETE',
    PROCESSING = 'PROCESSING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    EXPIRED = 'EXPIRED',
}

export const KYC_STATUS_MAP: Map<KycStatus, string> = new Map([
    [KycStatus.INCOMPLETE, 'KYC not complete'],
    [KycStatus.PROCESSING, 'KYC processing'],
    [KycStatus.APPROVED, 'KYC complete'],
    [KycStatus.REJECTED, 'KYC rejected'],
    [KycStatus.EXPIRED, 'KYC expired']
])

export const KYC_STATUS_NUMBER_MAP: Map<string, string> = new Map([
    ['0', 'KYC not complete'],
    ['1', 'KYC processing'],
    ['2', 'KYC complete'],
    ['3', 'KYC rejected'],
    ['4', 'KYC expired']
])